import { Routes, Route } from 'react-router-dom'
import { AdminLayout } from './AdminLayout'
import { AdminLogin } from './AdminLogin'
import { AdminDashboard } from './AdminDashboard'
import { AdminAccounts } from './AdminAccounts'
import { AdminCredentials } from './AdminCredentials'
import { AdminSettings } from './AdminSettings'

export function AdminApp() {
  return (
    <Routes>
      <Route path="/login" element={<AdminLogin />} />
      <Route path="/" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="accounts" element={<AdminAccounts />} />
        <Route path="credentials" element={<AdminCredentials />} />
        <Route path="settings" element={<AdminSettings />} />
      </Route>
    </Routes>
  )
}
